import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import {
    MAT_DIALOG_DATA,
    MatDialogRef,
    MatDialog,
} from '@angular/material/dialog';
import {  firstValueFrom } from 'rxjs';
import {
    debounceTime,
    distinctUntilChanged,
    take
} from 'rxjs/operators';
import { DocumentManagerService } from '../../services/document-manager.service';
import { DeltaBusinessService } from 'src/app/shared/services/delta-business.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatTabChangeEvent } from '@angular/material/tabs';

@Component({
    selector: 'app-document-share-dialog',
    templateUrl: './document-share-dialog.component.html',
    styleUrls: ['./document-share-dialog.component.scss']
})
export class DocumentShareDialogComponent implements OnInit {
    isLoading: boolean = true;
    roles = [];
    oldRoles = [];
    selectedRoles = [];
    findingEmployee = true;
    filteredEmployee = [];
    oldEmployees = [];
    oldUserIds = [];
    selectedEmployees = [];
    tabs = ['ROLES', 'INDIVIDUAL'];
    isChanged = false;
    public employeeSearchControl = new UntypedFormControl('');
    constructor(
        public dialog: MatDialog,
        private readonly documentManagerService: DocumentManagerService,
        public dialogRef: MatDialogRef<DocumentShareDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        public snackbar: MatSnackBar,
        public deltaBusinessService: DeltaBusinessService
    ) {
        this.documentManagerService
            .getRoleList()
            .pipe(take(1))
            .subscribe({
                next: (resp) => {
                    this.roles = resp;
                    this.isLoading = false;
                }
            });
        let itemId = '';
        if (data['Type'] === 'Folder') {
            itemId = data['Folder']['ItemId'];
        } else if (data['Type'] === 'File') {
            itemId = data['File']['ItemId'];
        }
        this.getObjectArtifactById(itemId)
    }

    private getObjectArtifactById(itemId){
        this.isLoading = true;
        this.documentManagerService.GetObjectArtifactById(itemId).then(
            (resp) => {
                console.log(resp);
                if (resp.length > 0) {
                    if (
                        resp[0]['SharedRoleList'] &&
                        resp[0]['SharedRoleList'].length > 0
                    ) {
                        this.oldRoles = resp[0]['SharedRoleList'];
                        this.selectedRoles = [...this.oldRoles];
                        console.log('shared roles', this.oldRoles);
                    }
                    if (
                        resp[0]['SharedUserIdList'] &&
                        resp[0]['SharedUserIdList'].length > 0
                    ) {
                        console.log(resp[0]['SharedUserIdList']);
                        this.oldUserIds = [...resp[0]['SharedUserIdList']];
                        firstValueFrom(this.documentManagerService
                            .GetEmployeesFromUserIds(this.oldUserIds))
                            .then(
                                (res: any) => {
                                    this.oldEmployees = res;
                                    this.selectedEmployees = res;
                                    this.getEmployee('.*');
                                },
                                (error) => console.log(error)
                            );
                    } else {
                        this.getEmployee('.*');
                    }
                } else {
                    this.getEmployee('.*');
                }
            },
            (error) => {
                this.isLoading = false;
                console.log(error);
            }
        );
    }

    ngOnInit() {
        //takeUntil(this._unsubscribeAll$),
        this.employeeSearchControl.valueChanges
            .pipe(debounceTime(650), distinctUntilChanged())
            .subscribe({
                next: (key) => {
                    if (key.length == 0) key = '.*';
                    this.getEmployee(key);
                }
            });
    }

    onNoClick(): void {
        this.dialogRef.close({ success: false, canceled: true });
    }
    shareViaEmail() {
        this.isLoading = true;
        this.shareInProgress = true;
        // const dialogRefn = this.dialog.open(ShareViaEmailDialogComponent,
        //     {
        //         width: '520px',
        //         data: this.data.File,
        //         disableClose: true
        //     })
        // dialogRefn.afterClosed().subscribe(resp=>{
        //     if(resp && resp.success){
        //         this.snackbar.open("Sent Successsfully",null,{duration:2000});
        //     }
        //     else if(resp && resp.fail){
        //         this.snackbar.open("Something went wrong",null,{duration:2000});
        //     }
        // })
        let newUsers = this.selectedEmployees
            .map((item) => item.UserId)
            .filter((item) => !this.oldUserIds.includes(item));
        let shareWithEmail = this.selectedEmployees
            .filter((item) => newUsers.includes(item.UserId))
            .map((item) => item.Email);
        if (shareWithEmail.length > 0) {
            const payload = {
                Purpose: 'DMSShareViaEmail',
                Language: 'en-US',
                Subject: {
                    DocumentName: this.data['File'].Name
                },
                DataContext: {
                    Sender: this.documentManagerService.loggedIuUser.DisplayName
                },
                To: [...shareWithEmail],
                Attachments: [this.data['File'].FileStorageId]
            };
            this.deltaBusinessService
                .sendEnqueMail(payload)
                .pipe(take(1))
                .subscribe({
                    next: (resp: any) => {
                        if (resp && resp.body && resp.body.StatusCode === 0) {
                            this.snackbar.open('Sent Successsfully', null, {
                                duration: 2000
                            });
                            this.dialogRef.close({ success: true, canceled: true });
                        } else {
                            this.dialogRef.close({
                                success: false,
                                canceled: false
                            });
                        }
                    }
                });
        }
    }
    shareInProgress = false;
    share() {
        this.documentManagerService.changeworkingState('busy');
        this.isLoading = true;
        this.shareInProgress = true;
        const roles = this.selectedRoles;
        const personIds = [];
        this.selectedEmployees.forEach((att) => {
            personIds.push(att['PersonId']);
        });
        if (
            this.data &&
            this.data.dmsConfig &&
            this.data.dmsConfig.moduleFeatureId
        ) {
            let revokedRoles = [];
            if (this.oldRoles.length > 0) {
                const revoked = this.oldRoles.filter(function (obj) {
                    return roles.indexOf(obj) === -1;
                });
                revokedRoles = revoked;
            }
            let itemId = '';
            if (this.data['Type'] === 'Folder') {
                itemId = this.data['Folder']['ItemId'];
            } else if (this.data['Type'] === 'File') {
                itemId = this.data['File']['ItemId'];
            }
            const userIds = [];
            for (let emp of this.selectedEmployees) {
                userIds.push(emp['UserId']);
            }
            this.deltaBusinessService
                .unshareObjectInDeltaWay({
                    ArtifactId: itemId,
                    UserIds: this.oldUserIds,
                    RoleNames: revokedRoles
                })
                .pipe(take(1))
                .subscribe({
                    next: (resp) => {
                        this.deltaBusinessService
                            .shareObjectInDeltaWay({
                                ArtifactId: itemId,
                                UserIds: userIds,
                                RoleNames: roles || []
                            })
                            .pipe(take(1))
                            .subscribe({
                                next: (resp) => {
                                    // this.isLoading = false;
                                    this.documentManagerService.changeworkingState(
                                        'idle'
                                    );
                                    console.log(resp);
                                    this.dialogRef.close({
                                        success: true,
                                        canceled: false
                                    });
                                },
                                error: (error) => {
                                    console.log(error);
                                    // this.isLoading = false;
                                    this.documentManagerService.changeworkingState(
                                        'idle'
                                    );
                                    this.dialogRef.close({
                                        success: false,
                                        canceled: true
                                    });
                                }
                            });
                    },
                    error: (error) => {
                        // this.isLoading = false;
                        this.documentManagerService.changeworkingState('idle');
                        this.dialogRef.close({
                            success: false,
                            canceled: false
                        });
                    }
                });
        } else {
            // Revoke Roles
            let revokedRoles = [];
            if (this.oldRoles.length > 0) {
                const revoked = this.oldRoles.filter(function (obj) {
                    return roles.indexOf(obj) === -1;
                });
                console.log('revokedRoles', revoked);
                revokedRoles = revoked;
            }
            this.documentManagerService.changeworkingState('busy');
            let itemId = '';
            if (this.data.Type === 'Folder') {
                itemId = this.data.Folder['ItemId'];
            } else if (this.data.Type === 'File') {
                itemId = this.data.File['ItemId'];
            }
            this.documentManagerService
                .Revoke(
                    itemId,
                    this.data.Type,
                    revokedRoles,
                    this.oldUserIds,
                    personIds
                )
                .then(
                    (resp) => {
                        if (this.data.Type === 'Folder') {
                            this.documentManagerService
                                .ShareFolder(
                                    this.data.Folder['ItemId'],
                                    personIds,
                                    roles || []
                                )
                                .then(
                                    (response) => {
                                        console.log(response);
                                        // this.isLoading = false;
                                        this.documentManagerService.changeworkingState(
                                            'idle'
                                        );
                                        this.dialogRef.close({
                                            success: true,
                                            canceled: false
                                        });
                                    },
                                    (error) => {
                                        // this.isLoading = false;
                                        this.documentManagerService.changeworkingState(
                                            'idle'
                                        );
                                        console.log(error);
                                        this.dialogRef.close({
                                            success: false,
                                            canceled: false
                                        });
                                    }
                                );
                        } else if (this.data.Type === 'File') {
                            this.documentManagerService
                                .ShareFile(
                                    this.data.File['ItemId'],
                                    personIds,
                                    roles || []
                                )
                                .then(
                                    (response) => {
                                        console.log(response);
                                        // this.isLoading = false;
                                        this.documentManagerService.changeworkingState(
                                            'idle'
                                        );
                                        this.dialogRef.close({
                                            success: true,
                                            canceled: false
                                        });
                                    },
                                    (error) => {
                                        // this.isLoading = false;
                                        this.documentManagerService.changeworkingState(
                                            'idle'
                                        );
                                        console.log(error);
                                        this.dialogRef.close({
                                            success: false,
                                            canceled: false
                                        });
                                    }
                                );
                        }
                    },
                    (error) => {
                        // this.isLoading = false;
                        this.documentManagerService.changeworkingState('idle');
                        console.log(error);
                        this.dialogRef.close({
                            success: false,
                            canceled: false
                        });
                    }
                );
        }
    }
    selectRole(role) {
        if (role == 'admin') return;
        this.isChanged = true;
        let idx = this.selectedRoles.indexOf(role);
        if (idx == -1) {
            this.selectedRoles.push(role);
        } else {
            this.selectedRoles.splice(idx, 1);
        }
    }
    getEmployee(key) {
        this.findingEmployee = true;
        this.documentManagerService
            .getEmployees(key)
            .pipe(take(1))
            .subscribe({
                next: (resp: any) => {
                    if (
                        resp.key == this.employeeSearchControl.value ||
                        (resp.key == '.*' && this.employeeSearchControl.value == '')
                    ) {
                        resp = JSON.parse(JSON.stringify(resp.response));
                        let selectedUsers = this.selectedEmployees.map(
                            (item) => item.UserId
                        );
                        this.filteredEmployee = resp.map((item) => {
                            return {
                                ...item,
                                Selected: selectedUsers.includes(item.UserId)
                            };
                        });
                        this.findingEmployee = false;
                    }
                }
            });
    }
    getDisplayNamePropertyOfObject = (obj: any) => {
        return obj ? obj.DisplayName : '';
    };

    selectEmployee(event) {
        this.isChanged = true;
        if (event.Selected) {
            this.removeEmployee(event);
        } else {
            event.Selected = true;
            this.selectedEmployees.push(event);
        }
    }
    removeEmployee(event) {
        this.isChanged = true;
        let idx = -1;
        for (let i = 0; i < this.selectedEmployees.length; i++) {
            if (this.selectedEmployees[i].ItemId == event.ItemId) {
                idx = i;
                break;
            }
        }
        if (idx >= 0) {
            event.Selected = false;
            this.selectedEmployees.splice(idx, 1);
        }
    }
    selectedTabIndex = 0;
    tabChanged(tabChangeEvent: MatTabChangeEvent): void {
        console.log('tabChangeEvent => ', tabChangeEvent);
        console.log('index => ', tabChangeEvent.index);
        this.selectedTabIndex = tabChangeEvent.index;
    }
}
